import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import CloudDownload from '@material-ui/icons/CloudDownload';
import { Button, translate as translateComponent } from 'react-admin';
import { getLegalDocument } from '../../../../action';

const TakenOverCleanerLetter = ({ className, getLegalDocumentClick }) => {
  const [idCompte, setId] = useState('012345678910');
  const [name, setName] = useState('Nettoyeur TOYEUR');
  const [address, setAddress] = useState('29 rue Abbey 75021 Paris');
  const [open, setOpen] = useState(false);
  const invertOpenStatus = () => {
    setOpen(!open);
  };
  const onChangeId = (newId) => {
    setId(newId.target.value);
  };
  const onChangeName = (newName) => {
    setName(newName.target.value);
  };
  const onChangeAddress = (newAddress) => {
    setAddress(newAddress.target.value);
  };

  return (
    <Fragment>
      <MenuItem
        className={className}
        variant="contained"
        onClick={invertOpenStatus}
        label="Annexe 7: Cleaner"
      >
        <ListItemText primary="Lettre Cleaner" />
      </MenuItem>
      <Dialog
        aria-labelledby="alert-dialog-title"
        open={open}
        onClose={invertOpenStatus}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle color="primary" id="alert-dialog-title">
          Départ en annexe 7
        </DialogTitle>
        <DialogContent style={{ display: 'flex', flexDirection: 'column' }}>
          <TextField
            style={{ marginBottom: '10px', width: '60%' }}
            label="Id du compte"
            defaultValue={idCompte}
            onChange={onChangeId}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <TextField
            style={{ marginBottom: '10px', width: '60%' }}
            label="Nom société repreneuse"
            defaultValue={name}
            onChange={onChangeName}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <TextField
            style={{ marginBottom: '10px', width: '60%' }}
            label="Adresse société repreneuse"
            defaultValue={address}
            onChange={onChangeAddress}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            label="resources.cleaner.actions.download"
            variant="contained"
            onClick={() => {
              getLegalDocumentClick('takenOverCleanerLetter', {
                idCompte: `${idCompte}`,
                sortantAccountName: `${name}`,
                sortantAccountAddress: `${address}`,
              });
              invertOpenStatus();
            }}
          >
            <CloudDownload />
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

TakenOverCleanerLetter.propTypes = {
  className: PropTypes.string,
  getLegalDocumentClick: PropTypes.func.isRequired,
};

TakenOverCleanerLetter.defaultProps = {
  className: undefined,
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    getLegalDocumentClick: (documentType, others) => {
      const payload = {
        id: ownProps.record.id,
        fullname: ownProps.record.fullname,
        documentType,
        ...others,
      };
      dispatch(getLegalDocument(payload));
    },
  };
};

const enhance = compose(translateComponent, connect(null, mapDispatchToProps));

export default enhance(TakenOverCleanerLetter);
